exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Confirm-module__wrapper___13F_O{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background-color:#fff;padding:1.5rem;min-width:600px;min-height:200px;border-radius:17px;z-index:200;display:grid;justify-items:center;gap:1rem;box-shadow:0 0 17.5px rgba(0,0,0,.08)}.Confirm-module__wrapper___13F_O .Confirm-module__buttons___3AIwP{display:grid;grid-auto-flow:column;gap:1rem}.Confirm-module__shade___1VKTy{position:relative;z-index:190}", ""]);

// exports
exports.locals = {
	"wrapper": "Confirm-module__wrapper___13F_O",
	"buttons": "Confirm-module__buttons___3AIwP",
	"shade": "Confirm-module__shade___1VKTy"
};